import React from 'react'
import EssenceHead from './EssenceHead'
import { CompositeWood, CountryWood, ExoticWood } from './EssenceProduct'
import { compositeWood, countryWood, exoticWood } from './EssenceProductData';
import { Link } from 'react-router-dom';
import { FaLongArrowAltRight } from "react-icons/fa";
import { FaLongArrowAltLeft } from "react-icons/fa";                                                                                                                                                                                                                                                                                                                    
import { useDispatch, useSelector } from 'react-redux';
import { stepUp, stepBack, resetStep } from '../../../Redux/Slice/stepSlice';
import { resetSelectedProject } from '../../../Redux/Slice/selectedProjectSlice';
import Section from './Section';


const Essence = () => {

  const steps = useSelector((state)=> state.step.value)
  const project = useSelector((state)=> state.selectedProject)

  const dispatch = useDispatch()

  const toUpper = (sectionName) => {
    let newSectionName = sectionName.toUpperCase()

    return newSectionName
  }

  const handleClickPrev = () => {
    dispatch(resetSelectedProject())
    dispatch(stepBack())
  }

  const handleClickNext = () => {
    
  }

  
  return (
    <div>
       <EssenceHead />
       <div>
       <div>
          <div className="py-2">
            <div className="container">
              <div className="">
                {/* <div className="">
                  <div className="mb-3">
                    <div className="bois-de-pays">
                      <span className="text-2 ">BOIS DE PAYS</span>
                    </div>
                  </div>
                  <p className="mb-4">Durée de vie moyenne d'une cinquantaine d'années</p>
                </div>
                <div className="row ">
                  {countryWood.map((product) => (
                    <div key={product.id} className="col-md-3 col-sm-6 col-12 px-3 mb-5">
                      <CountryWood product={product} name='country' />
                    </div>
                  ))}
                </div> */}
                <Section/>
                {/* <div className="">
                  <div className="mb-3">
                    <div className="bois-de-pays">
                      <span className="text-2">BOIS EXOTIQUE</span>
                    </div>
                  </div>
                  <p className="mb-4">Durée de vie moyenne d'une trentaine d'années</p>
                </div>
                <div className="row ">
                  {exoticWood.map((product) => (
                    <ExoticWood key={product.id} product={product} name='' />
                  ))}
                </div>
                <div className="">
                  <div className="mb-3">
                    <div className="bois-de-pays">
                      <span className="text-2">BOIS COMPOSITE</span>
                    </div>
                  </div>
                  <p className="mb-4">Durée de vie moyenne d'une trentaine d'années</p>
                </div>
                <div className="row ">
                  {compositeWood.map((product) => (
                    <CompositeWood key={product.id} product={product} />
                  ))}
                </div> */}
                <div className="mt-5">
                <div className="d-flex justify-content-center">
                  <div className="bois-de-pays me-2">
                    <span className="text-2 span">
                      <Link to="/" className='d-flex  align-items-center' onClick={ handleClickPrev() }>
                        <FaLongArrowAltLeft className='me-3'/>  MODIFIEZ
                      </Link>
                    </span>
                  </div>
                  <div className="btn btn-secondary box-green rounded-0" >
                    <span className="text-2 " >
                      <Link to="/structure" className="d-flex align-items-center ps-4" onClick={ ()=> dispatch(stepUp()) }>
                        SUIVANT  <FaLongArrowAltRight  className='ms-2'/>
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
                <div className="d-flex pt-5">
                  <div className="m-auto">
                    <nav aria-label="...">
                      <ul className="pagination pagination-sm rounded-0">
                        <li className="page-item active rounded-0" aria-current="page">
                          <Link className="page-link rounded-0 " to="#">
                            1
                          </Link>
                        </li>
                        <li className="page-item">
                          <span className="page-link rounded-0">2</span>
                        </li>
                        <li className="page-item">
                          <Link className="page-link rounded-0" to="#">
                            3
                          </Link>
                        </li>
                        <li className="page-item">
                          <Link className="page-link " to="#">
                            4
                          </Link>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
       </div>
    </div>
  )
}

export default Essence